import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Menu } from './pages/Menu';
import { Contact } from './pages/Contact';
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="about" element={<About data-id="element-7" />} data-id="element-6" />
          <Route path="menu" element={<Menu data-id="element-9" />} data-id="element-8" />
          <Route path="contact" element={<Contact data-id="element-11" />} data-id="element-10" />
        </Route>
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-12">
      <AnimatedRoutes data-id="element-13" />
    </BrowserRouter>;
}